import React from "react";
import { Link } from "react-router-dom";
import { useLocale } from "../context/LocaleContext";
import { useShop } from "../context/ShopContext";
import { PageTitle } from "../components/Shared";
import Seo from "../components/Seo";

const content = {
  it: {
    title: "Il nostro team",
    seoDesc: "Il team IdeaMedia: programmatori, grafici, videomaker e social media manager freelance al servizio delle aziende.",
    intro1: "La struttura della nostra web agency \u00e8 molto particolare: unisce differenti competenze, tutte provenienti dal settore freelance, garantendo una grande variet\u00e0 di servizi erogati e una spesa minima per il cliente finale. L'utilizzo di un team di freelancers consente di abbattere i costi fissi rispetto alla concorrenza, pur mantenendo comunque un'alta qualit\u00e0 di prodotti e servizi.",
    intro2: "Anche se costituito da freelancers, il nostro team si \u00e8 costruito e consolidato negli anni diventando una vera e propria squadra al servizio delle aziende, in grado di offrire servizi di notevole qualit\u00e0 in tempi rapidi e con costi ragionevoli.",
    squadTitle: "Breve presentazione della squadra",
    cta: "Guarda i nostri lavori",
  },
  en: {
    title: "Our team",
    seoDesc: "The IdeaMedia team: freelance developers, designers, videomakers and social media managers at the service of businesses.",
    intro1: "Our web agency has a very particular structure: it combines different skills, all coming from the freelance world, guaranteeing a wide variety of services and minimal costs for the final customer. Working with a team of freelancers cuts fixed costs compared to competitors while maintaining high quality products and services.",
    intro2: "Even though it is made up of freelancers, our team has grown and consolidated over the years into a true squad at the service of businesses, able to deliver high-quality services quickly and at reasonable costs.",
    squadTitle: "A short introduction of the squad",
    cta: "See our work",
  },
};

const members = [
  { img: "/images/team/ivano.jpg", skills: { it: "DIRETTORE ESECUTIVO - PROGRAMMATORE - PROJECT MANAGER", en: "EXECUTIVE DIRECTOR - DEVELOPER - PROJECT MANAGER" }, name: "Ivano Christian Mino", role: { it: "Fondatore - Direttore esecutivo", en: "Founder - Executive director" } },
  { img: "/images/team/gianni.jpg", skills: { it: "MONTATORE - REGISTA - VIDEOGRAFO - GRAPHIC MOTION", en: "EDITOR - DIRECTOR - VIDEOGRAPHER - MOTION GRAPHICS" }, name: "Gianni V.", role: { it: "Videomaker - Montaggio e graphic motion", en: "Videomaker - Editing & motion graphics" } },
  { img: "/images/team/sara.jpg", skills: { it: "PROGRAMMATORE PHP - JS - MYSQL - C#", en: "PHP - JS - MYSQL - C# DEVELOPER" }, name: "Sara P.", role: { it: "Application developer", en: "Application developer" } },
  { img: "/images/team/gianluca-d.jpg", skills: { it: "PROGRAMMATORE PHP - JS - MYSQL - C#", en: "PHP - JS - MYSQL - C# DEVELOPER" }, name: "Gianluca D.", role: { it: "Programming engineer", en: "Programming engineer" } },
  { img: "/images/team/giulio.jpg", skills: { it: "SOCIAL MEDIA MANAGER - META EXPERT - LINKEDIN", en: "SOCIAL MEDIA MANAGER - META EXPERT - LINKEDIN" }, name: "Giulio Tani", role: { it: "Social media manager", en: "Social media manager" } },
  { img: "/images/team/itria.jpg", skills: { it: "AMMINISTRAZIONE - FATTURAZIONE", en: "ADMINISTRATION - INVOICING" }, name: "Itria L.", role: { it: "Amministrazione - Fatturazione", en: "Administration - Invoicing" } },
  { img: "/images/team/gianluca-s.jpg", skills: { it: "GRAFICO PURO - LOGHI - VETTORIALI - ILLUSTRATOR - INDESIGN", en: "PURE GRAPHIC DESIGNER - LOGOS - VECTOR - ILLUSTRATOR - INDESIGN" }, name: "Gianluca S.", role: { it: "Grafico", en: "Graphic designer" } },
  { img: "/images/team/michele.jpg", skills: { it: "SVILUPPO APPLICAZIONI PYTHON - PHP - JS - MYSQL - C#", en: "PYTHON - PHP - JS - MYSQL - C# APPLICATION DEVELOPMENT" }, name: "Michele P.", role: { it: "Programming engineer", en: "Programming engineer" } },
];

const Team = () => {
  const { lang } = useShop();
  const { lp } = useLocale();
  const c = content[lang];

  return (
    <div data-testid="team-page">
      <Seo title={c.title} description={c.seoDesc} />
      <PageTitle title={c.title} />

      <section className="idm-section" style={{ paddingBottom: 40 }}>
        <div className="idm-container idm-narrow">
          <p className="idm-text">{c.intro1}</p>
          <p className="idm-text">{c.intro2}</p>
        </div>
      </section>

      <section className="idm-section idm-section-gray">
        <div className="idm-container">
          <h2 className="idm-section-title" style={{ textTransform: "uppercase", letterSpacing: 2 }}>{c.squadTitle}</h2>
          <span className="idm-separator" />
          <div className="idm-team-grid" data-testid="team-grid">
            {members.map((m) => (
              <div className="idm-team-card" key={m.name} data-testid="team-member">
                <div className="idm-team-photo">
                  <img src={m.img} alt={m.name} loading="lazy" />
                  <div className="idm-team-skills">
                    <span>{m.skills[lang]}</span>
                  </div>
                </div>
                <h3>{m.name}</h3>
                <p>{m.role[lang]}</p>
              </div>
            ))}
          </div>
          <div className="idm-center" style={{ marginTop: 50 }}>
            <Link to={lp("/portfolio")} className="idm-btn-yellow" style={{ animation: "none" }} data-testid="team-cta">
              {c.cta}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;
